<template>
  <v-app>
    <div>
      <AdSmp />
      <div class="flex-container">
        <div style="width: 100%">
          <v-container fluid>
            <v-row
              class="pb-4 mx-sm-4 mx-0"
              dense
            >
              <v-col
                cols="12"
              >
                <div
                  class="d-flex mb-2  align-center"
                  style="font-size: 12px;"
                >
                  <ListIcon
                    :style="`color: ${accentColor};width:6px;height:7px`"
                    class="mr-1 mb-1"
                  />
                  {{ currentNovel.name }} {{ currentNovelSiteTypeString }}
                </div>
                <v-layout
                  :style="`height: 60px;background-color: ${backgroundColor}`"
                  align-center
                  class="ma-0 pa-0"
                  d-flex
                  justify-start
                >
                  <div
                    :style="`width:5px; height:100%;background-color:${accentColor}`"
                    class="mr-4"
                  />
                  <div style="font-weight: bold;font-size: 18px;">
                    資料一覧
                  </div>
                  <v-spacer />
                  <v-menu
                    v-model="sortDialog"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-y
                    rounded="0"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="px-3 py-5 mr-4"
                        color="secondary"
                        elevation="0"
                        small
                        tile
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-img
                          class="mr-3 "
                          contain
                          height="22px"
                          src="../assets/sort.png"
                          width="22px"
                        />
                        並び替え
                      </v-btn>
                    </template>
                    <SortTypeSelect
                      :callback="selectSort"
                      :items="sortItems"
                      :sort-type="sortType"
                    />
                  </v-menu>
                </v-layout>
              </v-col>
              <v-col
                v-if="documentList && documentList.length==0"
                class="mb-5 px-3 mt-2"
                cols="12"
              >
                <v-card
                  class="mx-auto"
                  height="420"
                  style="padding-top:30px;padding-left:56px;padding-right:56px;background-color: var(--v-background2-base);"
                  text
                  width="440"
                >
                  <v-img src="../assets/empty2.png" />
                  <v-btn
                    color="secondary"
                    elevation="0"
                    height="60"
                    max-height="60"
                    style="margin-top:30px;border-radius: 8px;font-size: 17px;font-weight: bold"
                    width="100%"
                    @click="openEdit('create')"
                  >
                    <v-img
                      class="mr-3"
                      contain
                      max-height="22px"
                      max-width="22px"
                      src="../assets/file_w.png"
                    />
                    　新規追加する
                    <v-spacer />
                    <v-img
                      contain
                      max-height="22px"
                      max-width="22px"
                      src="../assets/plus_w.png"
                    />
                  </v-btn>
                </v-card>
              </v-col>

              <v-col
                v-if="documentList && documentList.length>0"
                class="pb-4 px-3"
                cols="12"
                lg="6"
                md="6"
                sm="6"
                xl="4"
              >
                <v-btn
                  color="secondary"
                  elevation="0"
                  height="60"
                  max-height="60"
                  style="border-radius: 8px;font-size: 17px;font-weight: bold;"
                  width="100%"
                  @click="openEdit('create')"
                >
                  <v-img
                    class="mr-3"
                    contain
                    max-height="22px"
                    max-width="22px"
                    src="../assets/clip_w.png"
                  />
                  　資料を追加する
                  <v-spacer />
                  <v-img
                    contain
                    max-height="22px"
                    max-width="22px"
                    src="../assets/plus_w.png"
                  />
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                lg="6"
                md="6"
                sm="6"
                xl="8"
              />
              <v-col
                v-for="(item) in documentList"
                :key="item.id"
                cols="12"
                lg="6"
                md="6"
                sm="6"
                xl="4"
              >
                <v-card
                  class="d-flex flex-column mb-4 mx-3"
                  min-height="188px"
                  flat
                  style="border-radius: 8px"
                  text
                  @click="openEdit(encodeHash(item.id))"
                >
                  <v-card-title class="pb-2 pt-3">
                    <ClipIcon style="width: 20px;height: 25px;" />
                    <div
                      class="mx-4 mt-1"
                      style="font-size: 16px;font-weight: bold;opacity: 70%"
                    >
                      {{ item.name }}
                    </div>
                  </v-card-title>
                  <div class="griditem-border mr-4 ml-4" />
                  <v-layout
                    align-content-start
                    align-start
                    class="pl-4 pt-4"
                    justify-start
                  >
                    <v-img
                      v-if="item.photoBlob"
                      :src="item.photoBlob"
                      height="100px"
                      width="100px"
                      @click.prevent="openGallery(item)"
                    />
                    <v-img
                      v-if="!item.photoBlob"
                      height="100px"
                      src="../assets/noimage.png"
                      width="100px"
                    />
                    <div
                      class="d-flex ma-0 pa-0 mx-2"
                      style="display: flex;justify-content: flex-end;flex-flow: column;width: 100%;"
                    >
                      <v-clamp
                        :max-lines="1"
                        autoresize
                        class="pa-0 ma-0 "
                        style="font-size: 12px;color: #797979;min-height: 16px;"
                      >
                        {{ item.content }}
                      </v-clamp>
                      <div class="d-flex align-center mt-2">
                        <ListIcon
                          :style="`color: ${accentColor};width:6px;height:7px`"
                          class="mr-1"
                        />
                        <div
                          class="griditem-content-bold mr-3"
                          style="padding-top:1px;"
                        >
                          最終更新日時
                        </div>
                      </div>
                      <div class="griditem-content pt-1 pa-0 ma-0 ml-2">
                        {{ item.updateDate |dayjs }}
                      </div>
                      <v-card-actions class="ma-0 pa-0 align-end">
                        <v-spacer />
                        <v-btn
                          class="ma-0 mr-2"
                          color="secondary"
                          elevation="0"
                          small
                          tile
                          @click="openEdit(encodeHash(item.id))"
                        >
                          編集
                        </v-btn>
                        <v-btn
                          class="ma-0 mr-1 align-end"
                          icon
                          @click.stop="deleteConfirm(item)"
                        >
                          <DeleteIcon style="width: 20px;height: 25px;" />
                        </v-btn>
                      </v-card-actions>
                    </div>
                  </v-layout>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <LightBox
            ref="lightbox"
            :media="images"
            :show-caption="false"
            :show-light-box="false"
          />
        </div>
        <AdPc />
      </div>
    </div>
    <v-dialog
      v-model="deleteDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          削除確認
        </v-card-title>
        <v-card-text v-if="deleteItemData!=null">
          指定の資料を削除してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="deleteDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="deleteItem(deleteItemData)"
          >
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="premiumDialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">
          プレミアムプラン限定機能
        </v-card-title>
        <v-card-text>
          資料の作成・編集はプレミアムプラン契約中のユーザーのみがご利用いただけます。
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="premiumDialog = false"
          >
            閉じる
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="$router.push({name: 'InputCard'});premiumDialog = false"
          >
            プレミアムプランへアップグレード
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import {mapState} from "vuex";
import AdSmp from '../component/AdSmp.vue';
import AdPc from '../component/AdPc.vue';
import dayjs from "dayjs";
import constant from "@/const"
import config from "@/const"
import firebase from "firebase/app";
import axios from "axios";
import ClipIcon from "@/component/svg/ClipIcon";
import DeleteIcon from "@/component/svg/DeleteIcon";
import ListIcon from "@/component/svg/ListIcon";
import VClamp from 'vue-clamp'
import SortTypeSelect from '../component/SortTypeSelect.vue';
import LightBox from 'vue-image-lightbox'
import sortByText from "@/component/sortByText";
export default {
  name: "Document",
  components: {
    AdSmp,
    AdPc,
    VClamp,
    ClipIcon,
    DeleteIcon,
    ListIcon,
    SortTypeSelect,
    LightBox,
  },
  data() {
    return {
      premiumDialog: false,
      deleteDialog: false,
      deleteItemData: null,
      saver: null,
      accentColor: null,
      backgroundColor: null,
      sortDialog: null,
      sortItems: constant.DOCUMENT_SORT_TYPE,
      documentList: null,
      images: [],
      novelId: config.HASH_IDS.decode(this.$route.params.novelid)[0],
      currentNovel: null,
      currentNovelSiteTypeString: null,
    }
  },
  computed: {
    ...mapState({
      user: state => state.userModule.user,
      sortType: state => state.userModule.user.fileListSort,
      isPremium: state => state.userModule.isPremium
    }),
  },
  watch: {
    $route: {
      handler: function () {
        this.novelId = config.HASH_IDS.decode(this.$route.params.novelid)[0]

        this.currentNovel = this.$store.state.NovelListModule.NovelList.find(element => element.id == this.novelId)
        if (this.currentNovel) {
          this.currentNovelSiteTypeString = config.siteTypeString(this.currentNovel.targetSite)
        }
        this.reloadItems()
      }, immediate: true
    },
    sortType: {
      handler: function () {
        this.invalidateSort()
      }, immediate: false
    }
  },
  created() {
  },
  destroyed() {
  },
  async mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
  },
  filters: {
    dayjs: function (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm');
    },

  },
  methods: {
    openEdit(id) {
      if (this.isPremium) {
        this.$router.push({name: 'DocumentEdit', params: {novelid: this.$route.params.novelid, documentid: id}})
      } else {
        this.premiumDialog = true
      }

    },
    encodeHash: function (id) {
      return constant.HASH_IDS.encode(id)
    },
    async reloadItems() {
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      this.novelId = config.HASH_IDS.decode(this.$route.params.novelid)[0]
      let ret = await axios.get(constant.API_URL + "auth/files", {
        headers: {"X-Firebase-Auth": token},
        params: {
          "novelId": config.HASH_IDS.decode(this.$route.params.novelid)[0],
        },
        data: {}
      })
      this.documentList = ret.data

      for (let i = 0; i < this.documentList.length; i++) {
        const value = this.documentList[i];
        const response = await axios.get(config.API_URL + `auth/file/${value.id}/photos`, {
          headers: {"X-Firebase-Auth": token},
        });
        const images = response.data;
        value.photoBlob = images.length !== 0 ? images[0].path : '';
      }
      this.invalidateSort()
    },
    invalidateSort() {
      this.documentList.sort((a, b) => {
        switch (this.sortType) {
          case 0:
            return sortByText.sortNum(b.updateDate,a.updateDate)
          case 1:
            return sortByText.sortNum(a.updateDate,b.updateDate)
          case 2:
            return sortByText.sortNum(b.createdDate,a.createdDate)
          case 3:
            return sortByText.sortNum(a.createdDate,b.createdDate)
        }
        return 0
      })
    },
    selectSort(sort) {
      this.$store.dispatch("userModule/updateParams", {"fileListSort": sort})
      this.$store.dispatch("userModule/saveSetting")
      this.sortDialog = false
    },
    deleteConfirm(deleteItemData) {
      this.deleteItemData = deleteItemData;
      this.deleteDialog = true;
    },
    // 削除実行
    async deleteItem(deleteItemData) {
      deleteItemData.modifiedTimestamp = Date.now()
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      axios.delete(constant.API_URL + "auth/file/" + deleteItemData.id, {
        headers: {"X-Firebase-Auth": token},
        data: {}
      }).then(value => {
        this.documentList = this.documentList.filter(function (item) {
          return item != deleteItemData
        })
      }).catch(reason => {
        alert("削除中にエラーが発生しました")
      });
      this.deleteDialog = false;	// 最後に削除確認ダイアログは閉じます。
    },
    openGallery(item) {
      this.images = [
        {
          thumb: item.photoBlob,
          src: item.photoBlob
        }
      ];
      this.$refs.lightbox.showImage(0);
    }
  }
}
</script>

<style>

.griditem-border {
  background-color: var(--v-bordercolor-base) !important;
  min-height: 2px;
}

.griditem-content-bold {
  font-size: 12px;
  font-weight: bold;
  color: var(--v-textcolor-base) !important;
}

.griditem-content {
  font-size: 12px;
  color: var(--v-textcolor-base) !important;
}

.text-button-small {
  font-size: 11px;
  color: var(--v-textcolor-base) !important;
}

.sub-header-margin {
  height: 100vh;
  overflow: auto;
  /*padding-bottom: 136px;*/
}

.flex-container {
  display: flex;
  justify-content: flex-end;
}

.flex-container > :first-child {
  margin-right: auto;
}
</style>
